export default "__VITE_ASSET__BUSch2IA__"